module.exports = __webpack_public_path__ + "assets/9b2c7a4458b266deaa69dcaee8d9daf4.png";